import { Optional } from 'utils/optional/optional';
import { MsftPrivateOffer } from '../types/MsftPrivateOffer';
import { MsftPrivateOfferSalesforceDataMapping } from '../types/MsftPrivateOfferSalesforceDataMapping';
import { MsftPrivateOfferSalesforceDataMappingResponseJSON } from '../types/MsftPrivateOfferSalesforceDataMappingResponseJSON';
import { msftPrivateOfferJSONToMsftPrivateOffer } from './msftPrivateOfferJSONToMsftPrivateOffer';

export const msftPrivateOfferSalesforceDataMappingJSONToMsftPrivateOfferSalesforceDataMapping =
  (
    salesforceDataMappingResponseJSON: MsftPrivateOfferSalesforceDataMappingResponseJSON,
  ): MsftPrivateOfferSalesforceDataMapping => {
    const {
      errors,
      mappedFields: { private_offer },
    } = salesforceDataMappingResponseJSON;

    const privateOffer: Partial<MsftPrivateOffer> = Optional.ofNullable(
      private_offer,
    )
      .map(msftPrivateOfferJSONToMsftPrivateOffer)
      .orElse(null);

    return {
      errors: errors ?? {},
      privateOffer,
    };
  };
